import { render, staticRenderFns } from "./CampanhaInternaPopupHost.vue?vue&type=template&id=6ddbb77e"
import script from "./CampanhaInternaPopupHost.vue?vue&type=script&lang=js"
export * from "./CampanhaInternaPopupHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports